import { GrcNotify, NotifyType } from '@grc/ui-package';
import { quoteService } from '../../common/constants/constants';
import { fetchQuoteMyWorkItemsSummary } from '../../common/constants/url-constants';
import { IOperationalCardCounts } from '../../models/home/operational-card.interface';

const inflightSummary = new Map<string, Promise<IOperationalCardCounts[]>>();

// Quote-domain counterpart to GetMyWorkItemsSummary (Order.Service) - hits Quotes.Service's
// v1/quotes/myworkitems instead. Kept as a separate service (own base service key `quote`,
// own inflight-dedupe map) rather than merged into GetMyWorkItemsSummary since the two hit
// different microservices behind different route/service constants.
export const GetQuoteWorkItemsSummary = async (
  fetchData: any,
  params: Record<string, unknown>
): Promise<IOperationalCardCounts[]> => {
  const key = JSON.stringify(params ?? {});
  const existing = inflightSummary.get(key);
  if (existing) return existing;

  const request = fetchData(
    fetchQuoteMyWorkItemsSummary,
    (message: string) => GrcNotify({ message, status: NotifyType.Error }),
    quoteService,
    params
  )
    .then((response: any) => {
      const data = response?.data;
      return (Array.isArray(data) ? data : data?.items ?? []) as IOperationalCardCounts[];
    })
    .catch((error: any) => {
      GrcNotify({ message: error.message, status: NotifyType.Error });
      return [] as IOperationalCardCounts[];
    })
    .finally(() => {
      inflightSummary.delete(key);
    });

  inflightSummary.set(key, request);
  return request;
};

export default GetQuoteWorkItemsSummary;
